import React, { Component } from 'react';
import Page from '../../common-components/Page';
import DownloadData from './DownloadData';
import DownloadReport from './DownloadReport';
import DownloadConfig from './DownloadConfig';
import Tabs from '../../common-components/Tabs';
import * as strings from '../../helpers/strings';

class DownloadScreen extends Component {
  render() {
    return (
      <Page title={strings.lblDownload}>
        <Tabs>
          <div label="Download Data">
            <DownloadData />
          </div>
          <div label="Download Report">
            <DownloadReport />
          </div>
          <div label="Download Configuration">
            <DownloadConfig />
          </div>
        </Tabs>
      </Page>
    );
  }
}

export default DownloadScreen;
